import React from 'react'
import { Slice } from 'gatsby'
import { SliceZone } from '@prismicio/react'

const components = {
  banner_with_caption: ({ slice }) => <Slice alias='bannerWithCaption' slice={slice} />,
  card_deck: ({ slice }) => <Slice alias='cardDeck' slice={slice} />,
  checklist: ({ slice }) => <Slice alias='checkList' slice={slice} />,
  contact: ({ slice }) => <Slice alias='contact' slice={slice} />,
  faq: ({ slice }) => <Slice alias='faq' slice={slice} />,
  google_reviews: ({ slice }) => <Slice alias='reviews' slice={slice} />,
  icon_list: ({ slice }) => <Slice alias='iconList' slice={slice} />,
  image: ({ slice }) => <Slice alias='image' slice={slice} />,
  manage_my_booking: ({ slice }) => <Slice alias='manageMyBooking' slice={slice} />,
  map: ({ slice }) => <Slice alias='map' slice={slice} />,
  map_of_locations: ({ slice, context }) => <Slice alias='mapOfLocations' slice={slice} context={context} />,
  quote: ({ slice }) => <Slice alias='quote' slice={slice} />,
  table: ({ slice }) => <Slice alias='table' slice={slice} />,
  text: ({ slice }) => <Slice alias='text' slice={slice} />,
  video: ({ slice }) => <Slice alias='video' slice={slice} />
}

const SliceList = ({ airport, productData, slices }) => {
  return (
    <SliceZone
      slices={slices}
      components={components}
      context={{
        airport: airport,
        productData: productData
      }}
      defaultComponent={() => null}
    />
  )
}

export default SliceList
